<template>
  <div id="data-list-list-view" class="data-list-container">
    <!-- {{courses}} -->
    <AddCourse :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData" />
    <ManageCourse v-if="addNewDatadialogue" :isSidebarActive="addNewDatadialogue" @closeSidebar="toggleManageCourse" :data="sidebarData" />
    <vs-table v-if="!addNewDatadialogue" ref="table" 
     pagination 
     :max-items="itemsPerPage" 
     search 
     :data="courses">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center">

          <!-- ADD NEW -->
          <div class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary" @click="addNewData">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Add New</span>
          </div>
        </div>
        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ courses.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : courses.length }} of {{ queriedItems }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="title">cid</vs-th>
        <vs-th sort-key="title">Title</vs-th>
        <vs-th sort-key="description">Description</vs-th>
        <vs-th sort-key="duration">Duration</vs-th>
        <vs-th sort-key="status">Status</vs-th>
        <vs-th sort-key="price">Price</vs-th>
        <vs-th>Action</vs-th>
      </template>

        <template slot-scope="{data}">
          <tbody :data="tr" :key="indextr" v-for="(tr, indextr) in data" @click="manageCourse(tr)" >
            <vs-tr  >

              <vs-td >
                <p  class="product-title font-medium truncate">{{ tr.cid }}</p>
              </vs-td>

              <vs-td >
                <p  class="product-title font-medium truncate">{{ tr.title }}</p>
              </vs-td>

              <vs-td>
                <p class="course-description">{{ tr.description }}</p>
              </vs-td>

              <vs-td>
                <p class="product-category">{{ tr.duration }}</p>
              </vs-td>

             <vs-td>
                <vs-chip :color="getStatusColor(tr.isEnabled ? 'live': 'Not_live')" class="product-order-status">{{ tr.isEnabled? 'live': 'Not live' }}</vs-chip>
              </vs-td>

              <vs-td>
                <p class="product-price">₹{{ tr.price }}</p>
              </vs-td>

              <vs-td class="whitespace-no-wrap">
                <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="editData(tr)" />                
                <!-- <feather-icon icon="EyeIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" class="ml-2" @click.stop="manageCourse" />                 -->
                <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteData(tr)" />
              </vs-td>

            </vs-tr >
          </tbody>
        </template>
    </vs-table>
  </div>
</template>

<script>
import AddCourse from '@/views/pages/courses/add-courses.vue'
// import ManageCourse from '@/views/pages/courses/manageCourse.vue'
import moduleDataList from '@/store/courses/moduleDataList.js'

export default {
  components: {
    AddCourse
    // ManageCourse
  },
  data () {
    return {
      // selected: [],
      // products: [],
      itemsPerPage: 4,
      isMounted: false,

      // Data Sidebar
      addNewDataSidebar: false,
      addNewDatadialogue: false,
      sidebarData: {}
    }
  },
  computed: {
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    courses () {
      return this.$store.state.courses.courses
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.courses.length
    }
  },
  methods: {
    addNewData () {
      this.sidebarData = {}
      this.toggleDataSidebar(true)
    },
    deleteData (data) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'warning',
        title: 'Confirm Delete',
        text: `You are about to delete "${data.title}"`,
        accept: () => {
          this.showDeleteSuccess(data)
        },
        acceptText: 'Delete'
      })
    },
    showDeleteSuccess (data) {
      this.$store.dispatch('courses/removeCourse', data._id)
        .then(response => {
          this.$vs.notify({
            color: 'success',
            title: 'Deleted',
            text: response.data.data
          })
        })
        .catch(err => { console.error(err) })
    },
    editData (data) {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      console.log('data going to edit', data)
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },
    manageCourse (data) {
      // console.log('course id for manageCoure', data._id)
      this.$router.push(`/pages/courses/${data._id}`).catch(() => {})
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      this.sidebarData = {data}
      this.toggleManageCourse(true)
    },
    getStatusColor (status) {
      if (status === 'on_hold')   return 'warning'
      if (status === 'live') return 'success'
      if (status === 'Not_live')  return 'danger'
      return 'primary'
    },
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
    },
    toggleManageCourse (val = false) {
      this.addNewDatadialogue = val
    },
    successMsg (message) {
      this.$vs.notify({
        title: 'Success',
        text: message,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'success'
      })
    },
    errorMsg (errMsg) {
      this.$vs.notify({
        title: 'Failed',
        text: errMsg,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger'
        // position:'bottom-left'
      })
    }
  },
  created () {
    if (!moduleDataList.isRegistered) {
      this.$store.registerModule('courses', moduleDataList)
      moduleDataList.isRegistered = true
    }
    this.$store.dispatch('courses/fetchCourses')
  },
  mounted () {
    this.isMounted = true
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          cursor: pointer;
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
